import theme from 'config/theme';
import { SUBSCRIPTION_BUNDLE_STATUS } from '../../constants';

export const getSubscriptionBundleColorStatus = (status) => {
  switch (status) {
    case SUBSCRIPTION_BUNDLE_STATUS.ACTIVE:
      return {
        textColor: theme.palette.greens.green900,
        iconColor: theme.palette.greens.green400,
        borderColor: theme.palette.greens.green200,
        bgColor: theme.palette.greens.green200,
      };
    case SUBSCRIPTION_BUNDLE_STATUS.COMPLETED:
      return {
        textColor: theme.palette.reds.codingRed900,
        iconColor: theme.palette.reds.codingRed600,
        borderColor: theme.palette.reds.codingRed200,
        bgColor: theme.palette.reds.codingRed200,
      };
    case SUBSCRIPTION_BUNDLE_STATUS.PENDING:
      return {
        textColor: theme.palette.yellows.yellow900,
        iconColor: theme.palette.yellows.yellow400,
        borderColor: theme.palette.yellows.yellow200,
        bgColor: theme.palette.yellows.yellow200,
      };
    case SUBSCRIPTION_BUNDLE_STATUS.PAID:
      return {
        textColor: theme.palette.blues.blue900,
        iconColor: theme.palette.blues.blue400,
        borderColor: theme.palette.blues.blue200,
        bgColor: theme.palette.blues.blue200,
      };
    default:
      return {
        textColor: theme.palette.grays.gray900,
        iconColor: theme.palette.grays.gray400,
        borderColor: theme.palette.grays.gray200,
        bgColor: theme.palette.grays.gray200,
      };
  }
};

export default {
  card: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '300px',
    minWidth: 0,
    gap: '16px',
    padding: '16px',
    border: `1px solid ${theme.palette.grays.gray300}`,
    borderRadius: '20px',
  },
  topCardContent: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    minHeight: '100px',
  },
  // Left top content of the card
  leftTopContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '50%',
  },
  leftTopContentBundleName: {
    fontSize: '18px',
    fontWeight: '600',
  },
  leftTopContentBundleDates: {
    color: theme.palette.grays.gray500,
    fontSize: '12px',
    whiteSpace: 'nowrap',
  },
  leftTopContentBundleDateRow: {
    display: 'flex',
    flexDirection: 'row',
    gap: '4px',
  },
  leftTopContentBundleDate: {
    color: theme.palette.grays.gray700,
  },

  // Right top content of the card
  rightTopContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    width: '50%',
  },
  statusChip: (status) => ({
    display: 'flex',
    flexDirection: 'row',
    width: 'fit-content',
    gap: '4px',
    alignItems: 'center',
    padding: '4px 8px',
    borderRadius: '32px',
    border: `1px solid ${getSubscriptionBundleColorStatus(status).borderColor}`,
    fontSize: '12px',
    fontWeight: '400',
  }),
  statusIcon: (status) => ({
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: getSubscriptionBundleColorStatus(status).iconColor,
  }),
  statusText: (status) => ({
    color: getSubscriptionBundleColorStatus(status).textColor,
    whiteSpace: 'nowrap',
  }),
  price: {
    fontSize: '20px',
    fontWeight: '600',
    color: theme.palette.grays.gray800,
  },

  divider: {
    color: theme.palette.grays.gray300,
  },

  // Bottom content of the card
  bottomCardContent: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: '8px',
    minWidth: 0,
  },
};
